import XkStar from './src/star.vue'

XkStar.install = function (Vue) {
  Vue.component(XkStar.name, XkStar)
}

export default XkStar



// WEBPACK FOOTER //
// ./src/components/module/star/index.js